import { agent } from '@shared/services/agent';
import { Moment } from "moment";
import { DATE_FORMAT } from "@shared/utils/DateUtils";
import { SimpleUserWithLocation } from '@features/whereabouts/models/movements.models';
import { OfficeEntity } from "./AdvanceHotDeskingService";

export async function requestUsersWithResponsibilitiesInOfficeOn(office: OfficeEntity, date: Moment): Promise<SimpleUserWithLocation[]> {
  return await agent.requests.get(`/api/responsibilities?officeId=${office.id}&date=${date.format(DATE_FORMAT)}`);
}
